import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const ArrowSort = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 20 20">
    <path d="M13.9609 7.93951L10.4951 4.3777C10.2213 4.09635 9.77864 4.09635 9.50778 4.3777L6.03909 7.93951C5.59932 8.39147 5.91095 9.16669 6.53421 9.16669H13.4658C14.089 9.16669 14.4006 8.39147 13.9609 7.93951Z" />
    <path d="M6.53421 10.8333H13.4658C14.089 10.8333 14.4006 11.6085 13.9609 12.0605L10.4951 15.6223C10.2213 15.9037 9.77864 15.9037 9.50778 15.6223L6.03909 12.0605C5.59932 11.6085 5.91095 10.8333 6.53421 10.8333Z" />
  </SvgIcon>
));

ArrowSort.displayName = 'ArrowSort';

export default ArrowSort;
